export default __webpack_public_path__ + "locales/pt-BR/Payments.json?hash=662e7ea68cb4a2b02c2927c74508d23a";